module.exports = __webpack_public_path__ + "img/emoji_95.2c84d386.png";